module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Xfd5"))).then(() => parcelRequire('4IGTl'));